import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import CustomIcon from '../components/Utility/Customicon.vue'

Vue.use(Vuetify);

export default new Vuetify({

    icons: {
        values: {
            custom: {
                component: CustomIcon
            }
        }
    }
});
